import type { SVGProps } from 'react';

const SvgForward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M12 8V4l8 8-8 8v-4H4V8z" />
  </svg>
);
export default SvgForward;
